// extracted by mini-css-extract-plugin
module.exports = {"cardDetail__jobName":"cardDetail__jobName"};